import { useQueryClient } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { clearAllBrowserStorage } from '../lib/storage/localStorage'

export const useLogout = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const logout = () => {
    clearAllBrowserStorage()
    dispatch({ type: 'RESET_STATE' })
    queryClient.clear()
    navigate('/login')
  }
  return logout
}
